import ShellyAvatar from './ShellyAvatar'
import ShellyAvatarFallback from './ShellyAvatarFallback'
import SmallShellyAvatar from './SmallShellyAvatar'

export default ShellyAvatar
export { ShellyAvatarFallback, SmallShellyAvatar }
